import React from "react";
import { Link } from 'react-router-dom';
import { RenderCampus, RenderSchool, RenderLearningMethod, RenderProgrammeType } from "../../../../utils/CommonGroupingItem";
import { TABLE_DATE_FORMAT } from "../../../../utils/Constants";
import moment from "moment";

const QualificationCard = ({ item, courseType, isLearningMethod = true, isCampus = true, isProgrammeType = false, isIntake = true}) => {
    const link =
    courseType === 'mentored'
    ? `/courseAdministration/Programmes/programme/open/${item?.programId || item?.id}/details`
    : `/courseAdministration/coursesdetails/${item?.programId || item?.id}/detailCourses/show`;
    const campusMap = { 
        'online': "Online",
        'mid-john': "Midrand - Block A, Main Campus",
        'mid-john-b': "Midrand - Block B, Artisan Campus",
        'mid-john-c': "Midrand - Block C, Artisan Campus",
        'cape-town': "Cape Town Campus",
        'gdc': "Greenside - Block A, Laubscher Building",
        'gdc-b': "Greenside - Block B, Achitecture Campus",
        'on_site': "On Site",
        'hatfield': "Hatfield Campus"
    };
    return (
        
        <a href={link} className="matched-program-item">
        <div>
        <div className="course-name">{item?.course}</div>
        {(item?.start && item?.end) && (<>{moment.unix(item?.start).format(TABLE_DATE_FORMAT)} - {moment.unix(item?.end).format(TABLE_DATE_FORMAT)}</>)}
        <div className="school-card-content">
        {/* {item?.typeName && <div className={item?.typeColor || ""}>{item?.typeName}</div>}  */}
        {(item?.schoolName || item?.school_type) && (item?.school_type ? RenderSchool(item?.school_type)?.html : item?.schoolName)}        
        {isLearningMethod &&  item?.learningMethod && RenderLearningMethod(item?.learningMethod)?.html}
        {isCampus && item?.campus_selected && RenderCampus(campusMap[item?.campus_selected])?.html}
        {isProgrammeType && item?.program_type && RenderProgrammeType(item?.program_type)?.html}
        {isIntake && item?.Intake && <div>{item?.Intake}</div>}            
        </div>
        <div className="AddIcon">
        <i className="fa-regular fa-folder-open"></i>
        </div>
        </div>
        </a>
    );
};

export default QualificationCard;
